import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from "@angular/core";

import {
  ModalDismissReasons,
  NgbActiveModal,
  NgbModal,
  NgbModalOptions,
} from "@ng-bootstrap/ng-bootstrap";
import { EventFormCustomFormType } from "../event-page-models/event-form-custom-form-type";

@Component({
  selector: "generic-parent-events-page-main-modal-container",
  templateUrl: "./parent-events-page-main-modal-container.component.html",
  styleUrls: ["./parent-events-page-main-modal-container.component.scss"],
})
export class ParentEventsPageMainModalContainerComponent implements OnInit {
  @Output("result") public modalResult: EventEmitter<any> =
    new EventEmitter<boolean>();
  public isConedEvent: boolean = false;
  public modalIdInput: string;
  public readonly EventFormCustomFormType = EventFormCustomFormType;

  constructor(
    private modalService: NgbModal,
    public activeModal: NgbActiveModal,
    private changeDetector: ChangeDetectorRef
  ) {}

  public _customEventType: EventFormCustomFormType;

  @Input("customEventType")
  public set customEventType(value: EventFormCustomFormType) {
    if (value && value !== this._customEventType) {
      this._customEventType = value;
    }
  }

  @Input("modalEventIdInput")
  public set modalEventIdInput(value: string) {
    if (value && value !== this.modalIdInput) {
      this.modalIdInput = value;
    }
  }

  public static closeConfirmation = () => {
    return confirm("כל השינויים שהזנת ימחקו. האם את/ה בטוח/ה?");
  };

  // tslint:disable-next-line:member-ordering
  public static readonly modalOptions: NgbModalOptions = {
    backdropClass: "create-event-backdropClass",
    backdrop: true,
    windowClass: "create-event-window-class",
    beforeDismiss: () => {
      return ParentEventsPageMainModalContainerComponent.closeConfirmation();
    },
  };

  public ngOnInit(): void {
    this.modalIdInput = this.modalIdInput || "new";
    this._customEventType =
      this._customEventType || EventFormCustomFormType.common;
  }

  public modalClose(result: string) {
    this.activeModal.close(result);
  }

  public modalActionsHandler($event: any) {
    if ($event === "close") {
      return this.modalClose(null);
    } else if ($event === "save") {
      return this.modalClose(null);
    }
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/events-screen/parent-events-page-main-modal-container/parent-events-page-main-modal-container.component.ts